import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicContentColumns {
  constructor(section) {
    this.el = section.el;
    this.section = section;

    initCarousel(
      this.el,
      {
        type: 'loop',
        perPage: 1,
        gap: '1.5rem',
        arrows: true,
        pagination: true,
        focus: 'center',
        mediaQuery: 'min',
        padding: {
          right: 48,
          left: 48,
        },
        breakpoints: {
          [unitlessBreakpoints.xs]: {
            padding: {
              right: 64,
              left: 64,
            },
          },
          [unitlessBreakpoints.sm]: {
            padding: {
              right: 128,
              left: 128,
            },
          },
          [unitlessBreakpoints.md]: {
            gap: '2.5rem',
            padding: {
              right: 200,
              left: 200,
            },
          },
          [unitlessBreakpoints.lg]: {
            arrows: false,
            pagination: false,
            destroy: true,
          },
        },
      },
      true,
    );
  }
}
